var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dropdown",
    { staticClass: "avatar-container", attrs: { trigger: "click" } },
    [
      _c("div", { staticClass: "avatar-wrapper" }, [
        _c("span", [
          _vm._v(
            _vm._s(_vm.currentUser.name) +
              " (" +
              _vm._s(_vm._f("userTypeChar")(_vm.currentUser.type)) +
              ", " +
              _vm._s(_vm.currentUser.loginName) +
              ", " +
              _vm._s(_vm.currentUser.id) +
              ")"
          )
        ]),
        _vm._v(" "),
        _c("i", { staticClass: "el-icon-caret-bottom" })
      ]),
      _vm._v(" "),
      _c(
        "el-dropdown-menu",
        {
          staticClass: "user-dropdown",
          attrs: { slot: "dropdown" },
          slot: "dropdown"
        },
        [
          _c("el-dropdown-item", [
            _c("span", { staticStyle: { display: "block" } }, [
              _vm._v(
                "当前用户 " +
                  _vm._s(_vm.currentUser.name) +
                  " (" +
                  _vm._s(_vm._f("userTypeChar")(_vm.currentUser.type)) +
                  ", " +
                  _vm._s(_vm.currentUser.loginName) +
                  ", " +
                  _vm._s(_vm.currentUser.id) +
                  ")"
              )
            ])
          ]),
          _vm._v(" "),
          _c("el-dropdown-item", [
            _c(
              "a",
              {
                attrs: {
                  href: "/ticket-vue/u?id=" + this.currentUser.id,
                  target: "_blank"
                }
              },
              [_vm._v("个人信息")]
            )
          ]),
          _vm._v(" "),
          _c("el-dropdown-item", [
            _c("a", { on: { click: _vm.goUserDepartment } }, [
              _vm._v("部门和上下级")
            ])
          ]),
          _vm._v(" "),
          _c("el-dropdown-item", [
            _c("a", { on: { click: _vm.goRolePermission } }, [
              _vm._v("角色权限信息")
            ])
          ]),
          _vm._v(" "),
          _c("el-dropdown-item", [
            _c("a", { on: { click: _vm.goOrganization } }, [
              _vm._v("企业(租户)信息")
            ])
          ]),
          _vm._v(" "),
          _c("el-dropdown-item", [
            _c("a", { on: { click: _vm.showUserNotifyConfig } }, [
              _vm._v("通知设置")
            ])
          ]),
          _vm._v(" "),
          _c("el-dropdown-item", [
            _c("a", { on: { click: _vm.clearCache } }, [_vm._v("清理缓存")])
          ]),
          _vm._v(" "),
          _c("el-dropdown-item", [
            _c("a", { on: { click: _vm.goHelp } }, [_vm._v("帮助")])
          ]),
          _vm._v(" "),
          _c("el-dropdown-item", [
            _c("a", { on: { click: _vm.goYijian } }, [_vm._v("意见反馈")])
          ]),
          _vm._v(" "),
          _c("el-dropdown-item", [
            _c("a", { on: { click: _vm.goAbout } }, [_vm._v("关于系统")])
          ]),
          _vm._v(" "),
          _c("el-dropdown-item", [
            _c("a", { attrs: { href: "/ticket" } }, [_vm._v("主页")])
          ]),
          _vm._v(" "),
          _c("el-dropdown-item", [
            _c("a", { on: { click: _vm.goLogout } }, [_vm._v("退出登录")])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f8bf785e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8bf785e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/CurrentUser.vue
// module id = 928
// module chunks = 75